import { useLayoutEffect, useState } from 'react';

import { tokenStorage } from 'api/client/helpers/tokenStorage';
import { useTranslation } from 'libs/i18n';
import { ROUTES } from 'libs/navigation';
import { useUser } from 'libs/providers';

import { useSetPassword } from '../hooks';
import { SetPasswordView } from '../views/SetPasswordView';

export const SetPasswordContainer = () => {
  const { t } = useTranslation();
  const { user } = useUser();

  const [loading, setLoading] = useState(true);

  const {
    formErrors,
    submitLoading,
    isTwoFactorAuthentication,
    onSubmit,
    onBackPassword,
  } = useSetPassword(user ? user.otp?.verified || false : true);

  useLayoutEffect(() => {
    const accessToken = tokenStorage.getAccessToken();
    if (!accessToken) {
      window.location.replace(ROUTES.login.fullPath);
    } else {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return null;
  }

  return (
    <SetPasswordView
      formErrors={formErrors}
      isTwoFactorAuthentication={isTwoFactorAuthentication}
      submitLoading={submitLoading}
      subtitle={t('auth.setPassword.subtitle')}
      title={t('auth.setPassword.title')}
      onBackPassword={onBackPassword}
      onSubmit={onSubmit}
    />
  );
};
